import styled from 'styled-components';

export const PageContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  min-height: 70vh;
`;

export const PageTitle = styled.h1`
  font-family: 'Abel', sans-serif;
  font-size: 2.5rem;
  font-weight: 300;
  letter-spacing: 1px;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 2rem;
  text-align: center;
`;

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 3rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const MainSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const Section = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  border: 1px solid #e0e0e0;
`;

export const SectionTitle = styled.h2`
  font-family: 'Abel', sans-serif;
  font-size: 1.3rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const OrderItem = styled.div`
  display: grid;
  grid-template-columns: 80px 1fr auto;
  gap: 1rem;
  padding: 1rem 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`;

export const ItemImage = styled.div`
  aspect-ratio: 1;
  background-color: #f5f5f5;
  border-radius: 4px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const NoImage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Abel', sans-serif;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ItemDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const ItemBrand = styled.div`
  font-family: 'Abel', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  color: #b8964a;
  text-transform: uppercase;
`;

export const ItemModel = styled.div`
  font-family: 'Abel', sans-serif;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const ItemRef = styled.div`
  font-family: 'Abel', sans-serif;
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ItemPrice = styled.div`
  font-family: 'Abel', sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
  color: #b8964a;
`;

export const AddressBox = styled.div`
  font-family: 'Abel', sans-serif;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 1.6;

  p {
    margin: 0.25rem 0;
  }
`;

export const PaymentInfo = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-start;

  span {
    font-size: 2rem;
  }

  strong {
    font-family: 'Abel', sans-serif;
    font-size: 1.1rem;
    color: ${({ theme }) => theme.colors.text.primary};
  }

  p {
    font-family: 'Abel', sans-serif;
    font-size: 0.9rem;
    color: ${({ theme }) => theme.colors.text.secondary};
    margin: 0.5rem 0 0;
  }
`;

export const SummarySection = styled.div`
  background-color: white;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 2rem;
  height: fit-content;
  position: sticky;
  top: 2rem;

  @media (max-width: 1024px) {
    position: static;
  }
`;

export const SummaryTitle = styled.h2`
  font-family: 'Abel', sans-serif;
  font-size: 1.5rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 0;
  font-family: 'Abel', sans-serif;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #e0e0e0;
  margin: 1rem 0;
`;

export const SummaryTotal = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;
  font-family: 'Abel', sans-serif;
  font-size: 1.5rem;
  font-weight: 600;
  color: #b8964a;
`;

export const ConfirmButton = styled.button`
  width: 100%;
  background-color: #b8964a;
  border: none;
  color: white;
  font-family: 'Abel', sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
  padding: 1.2rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 1.5rem;

  &:hover:not(:disabled) {
    background-color: #a07f3a;
    transform: translateY(-2px);
    box-shadow: 0 4px 14px rgba(184, 150, 74, 0.35);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const BackButton = styled.button`
  width: 100%;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-family: 'Abel', sans-serif;
  font-size: 0.95rem;
  padding: 1rem;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #b8964a;
  }
`;

export const ErrorMessage = styled.div`
  background-color: #ffebee;
  border: 1px solid #ff6b6b;
  border-radius: 6px;
  padding: 1rem;
  margin-top: 1rem;
  font-family: 'Abel', sans-serif;
  font-size: 0.95rem;
  color: #c62828;
`;

export const DiscountBlock = styled.div`
  padding: 0.75rem 0 0.5rem;
  font-family: 'Abel', sans-serif;
`;

export const DiscountInputRow = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const DiscountInput = styled.input`
  flex: 1;
  padding: 0.6rem 0.8rem;
  border: 1.5px solid #e0e0e0;
  border-radius: 6px;
  font-family: 'Abel', sans-serif;
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:focus {
    outline: none;
    border-color: #b8964a;
  }
`;

export const DiscountApplyButton = styled.button`
  padding: 0.6rem 1rem;
  border: none;
  background: #b8964a;
  color: white;
  font-family: 'Abel', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: #a0864a;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const DiscountError = styled.div`
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #c62828;
`;

export const DiscountAppliedRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(184, 150, 74, 0.08);
  border-left: 3px solid #b8964a;
  padding: 0.6rem 0.8rem;
  border-radius: 4px;
  font-size: 0.95rem;
  color: #2e7d32;
`;

export const DiscountAppliedRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
`;

export const DiscountRemoveBtn = styled.button`
  background: transparent;
  border: none;
  color: #888;
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
  padding: 0 0.25rem;

  &:hover { color: #c62828; }
`;
